import React, { useEffect } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import firebaseApp from '../../../firebase-app';
import { SxStyle } from '../../../types';
import svStrings from '../../../sv-strings';
import { useStringsContext } from '../../../contexts/strings';
import Paper from '@mui/material/Paper';
import { collection, doc, updateDoc } from 'firebase/firestore';
import SceneHeader from '../../common/scene/scene-header';
import ScenePage from '../../common/scene/scene-page';

const styles: SxStyle = {
  container: {
    width: '100%',
    height: 'calc(100% - 80px)',
    marginTop: 4,
  },
};

const columns: GridColDef[] = [
  {
    field: 'abbrv',
    headerName: svStrings.tickerConfigurator.teamAbbrv,
    width: 180,
    editable: false,
  },
  {
    field: 'everySportId',
    headerName: svStrings.tickerConfigurator.everySportId,
    type: 'number',
    width: 180,
    editable: false,
  },
  {
    field: 'ticketUrl',
    headerName: svStrings.tickerConfigurator.tickerUrl,
    type: 'string',
    width: 400,
    editable: true,
  },
];

export default function TicketConfigurator() {
  const { strings } = useStringsContext();
  const [rows, setRows] = React.useState<any[]>([]);
  const [data, loading, error] = useCollectionData(collection(firebaseApp.db, 'ticket-config'));

  useEffect(() => {
    if (data && !loading) {
      setRows(data.map((x) => ({ ...x, id: x.abbrv })));
    }
    return () => {};
  }, [data, loading]);

  const processRowUpdate = React.useCallback(async (updatedRow: any) => {
    const docRef = doc(firebaseApp.db, `ticket-config/${updatedRow.id}`);
    await updateDoc(docRef, updatedRow);
    return updatedRow;
  }, []);

  if (!data || loading || error) {
    return null;
  }

  return (
    <ScenePage title={strings.appBar.tickets} breadCrumps={[strings.appBar.superAdmin]}>
      <SceneHeader title={strings.appBar.tickets} />
      <Paper elevation={2} sx={styles.container}>
        <DataGrid rows={rows} columns={columns} processRowUpdate={processRowUpdate} autoPageSize />
      </Paper>
    </ScenePage>
  );
}
